import { render, staticRenderFns } from "./HeaderEmployee.vue?vue&type=template&id=27dfda26&scoped=true&"
import script from "./HeaderEmployee.vue?vue&type=script&lang=js&"
export * from "./HeaderEmployee.vue?vue&type=script&lang=js&"
import style0 from "./HeaderEmployee.vue?vue&type=style&index=0&id=27dfda26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dfda26",
  null
  
)

export default component.exports